"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Checkbox_1 = tslib_1.__importDefault(require("@mui/material/Checkbox"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
/**
 * This component is used to select rows for executing bulk actions in a table.
 * Pass a callback to onChange which adds/removes the recordId for that row to a list.
 * Execute bulk actions using the selected rows. See the design system for more details: https://zeroheight.com/5a26bc445/p/213964-table/b/09d7b1
 * @category component
 */
const CheckboxCell = ({ columnId, checkboxProps = {}, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps },
        react_1.default.createElement(Checkbox_1.default, { ...checkboxProps })));
};
exports.default = CheckboxCell;
